/* eslint-disable import/prefer-default-export */
function toCamelCase(str) {
  return str.replace(/([-_]\w)/g, (match) => match.toUpperCase().replace('_', ''))
}

export { toCamelCase }
